import { createAction } from "@redux/actions/actionCreators";

const [useSetVariantStatus, setVariantStatus] = createAction<{
  productUuid: string;
  variantKey: string;
  status: "active" | "hidden";
}>("product/setVariantStatus");

export default useSetVariantStatus;
export { setVariantStatus };
